import { render } from "./SolutionsComponent.vue?vue&type=template&id=0fc6c6d6&scoped=true"
import script from "./SolutionsComponent.vue?vue&type=script&lang=js"
export * from "./SolutionsComponent.vue?vue&type=script&lang=js"

import "./SolutionsComponent.vue?vue&type=style&index=0&id=0fc6c6d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fc6c6d6"

export default script